export default __webpack_public_path__ + "static/media/soso-logo-normal.5990e201.png";